import type { FaireProductEntity } from "../../entity_types/product";

export const p_tnurzuhjsr: FaireProductEntity = {
  token: "p_tnurzuhjsr",
  type: "product",
  name: "Hummingbird Swedish Cloth Set",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/e6602bf3c9581c0eafdb199e7184aabd9afd189e20ebc5bbea1d8665f2ab0af1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62f180128efdb8c82c7a1bebf1392f513006d6e9ac21006d908aec0e3081bb2a.jpeg",
    "https://cdn.faire.com/fastly/dfb0d37aca6976faf85658561fbd9ab31c50d1dc39e2239db1af8fe8d41ca568.jpeg",
    "https://cdn.faire.com/fastly/fdf7c72ad76732bc869a7308d4e7e6990055b0ecbaa1e3007ddb00a177aa2930.jpeg",
    "https://cdn.faire.com/fastly/31f84863be2cc38794dfc5471e79e0b4f26d831328cd1a21b49a816672aff436.jpeg"
  ],
  priceDollars: 5.5,
  description: "Safe to use on all types of surfaces, eco-friendly Swedish Dishcloths dry quickly and are antibacterial for more hygienic cleaning with reduced waste. This set of 2 Swedish Dishcloths from our Folk Art Collection features intricate flower and bird themed patterns on each cloth. Botanical designs are replicated from original hand illustrated art inspired by folk art. Our Hummingbird Swedish dishcloth set is ultra-absorbent and conveniently machine washable for easy cleaning and reuse. Dishcloths are attached to header card with hole for easy store rack display. A stylish garden-themed set of reusable dishcloths perfect for replacing dull sponges and paper towels with long-lasting colorful designs.",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:09.281Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
